var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileUploadSuccessIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 4H35L41.5 10.5L48 17V52H8V4Z",
    fill: "#E4F3E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 4L41.5 10.5L48 17H35V4Z",
    fill: "#B7E0C0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 42C22.477 42 18 37.523 18 32C18 26.477 22.477 22 28 22C33.523 22 38 26.477 38 32C38 37.523 33.523 42 28 42ZM27.003 36L34.073 28.929L32.659 27.515L27.003 33.172L24.174 30.343L22.76 31.757L27.003 36Z",
    fill: "#4AB261"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploadSuccessIcon);
export default __webpack_public_path__ + "static/media/fileUploadSuccessIcon.702ba076ffee22bdab51b088b8bc6eaa.svg";
export { ForwardRef as ReactComponent };